import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import logo from '../../images/popin-logo-horizontal.svg';
import { GLOBAL_PATH_PREFIX } from '../../constants';
import Logger from '../../util/Logger';
import User from '../../models/User';
import { RoleType } from '../../models/RoleType';
import Tenant from '../../models/Tenant';
import './Navbar.css';
import '../shared/UserAvatar.css';
// import { NavigationUtils } from '../../util/NavigationUtils';
import AccountDropdown from './AccountDropdown';
// import { EnterpriseAnalytics } from '../../analytics/EnterpriseAnalytics.js'

class EnterpriseNavbar extends React.Component {

  handleBackToPopin = ($event) => {
    // $event.preventDefault();
    // EnterpriseAnalytics.backToPopin();
    // NavigationUtils.backToPopin();
  };

  render () {
    const { orgName } = this.props;
    return (
      <nav className="navbar navbar-expand navbar-light enterprise-navbar row fixed-top">
        <div className="align-items-center w-100 row no-gutters mr-3">
          <div className="nav-item fix-ie">
            <Link to={ `${GLOBAL_PATH_PREFIX}/dashboard` }>
              <img src={ logo } alt="POPin Navbar Logo" className="navbar-brand" />
            </Link>
          </div>

          <div className="font-size-lg navbar-org-name text-truncate col-3 col-xl-4 text-left pl-3">
            { orgName }
          </div>

          <div className="fix-ie" />

          <div>
            <div className="row d-flex h-100">

              <div className="v-divider" />

              <Link
                className="px-2 px-lg-3 px-xl-4 font-size-sm navbar-item clickable route fix-ie"
                // onClick={ this.handleBackToPopin }>
                to={ `${GLOBAL_PATH_PREFIX}/dashboard` }
                >
                <div className="row no-gutters d-flex h-100">
                  <svg
                    version="1.1"
                    className="m-auto fix-ie"
                    id="POPinIcon"
                    width="20px"
                    height="20px"
                    x="0px"
                    y="0px"
                    viewBox="0 0 66.5 72.9">
                    <g>
                      <path
                        className="popinIcon" d="M0.1,32.1C0.7,29,1.2,25.9,2.4,23C8,9.9,17.7,2.2,31.8,0.3C41.6-1,50.3,1.9,57.4,8.9c5.2,5,8.2,11.2,8.9,18.5
                      c1,11.2-2.8,20.4-11.5,27.5c-4,3.3-8.6,5.2-13.7,6c-1.8,0.3-1.8,0.3-1.8,2v6.5c0,2.3-1.2,3.5-3.5,3.5c-9-0.3-17-3.3-23.8-9.4
                      C5.3,57.5,1.4,50,0.2,41.1c0-0.2-0.1-0.4-0.2-0.6C0.1,37.7,0.1,34.9,0.1,32.1z M35.3,5.9c-1.5-0.1-3.4,0.2-5.3,0.5
                      C14.1,9.6,3.5,25,6.2,41.4C7.5,48.8,11,55,16.8,59.8c4.4,3.7,9.4,5.9,15.1,6.8c1.5,0.2,1.5,0.2,1.5-1.3c0-2.1,0-4.2,0-6.3
                      c0-2.6,1.1-3.7,3.7-3.7c1.3,0,2.6-0.1,3.9-0.4c13-2.5,21.2-14.5,19.5-27.5C58.9,14.9,48.4,5.8,35.3,5.9z" />
                    </g>
                  </svg>
                  { /* Space out the nav on large screens */ }
                  <div className="fix-ie m-auto row no-gutters h-100 align-items-center">
                    <div className="mr-2 fix-ie display-if-large-enough" />
                    <div className="m-auto fix-ie display-if-large-enough">Back to POPin</div>
                  </div>
                </div>
              </Link>

              <div className="v-divider" />

              <NavbarRoute
                location={ this.props.location }
                path={ `${GLOBAL_PATH_PREFIX}/analytics` }
                icon="assessment"
                name="Analytics"
              />

              <div className="v-divider" />

              {this.props.isPOPinAdmin && (
                <NavbarRoute
                  location={ this.props.location }
                  path={ `${GLOBAL_PATH_PREFIX}/analytics/admin/banner` }
                  icon="announcement"
                  name="Banner"
                />
              )}

              <div className="v-divider" />

              <NavbarRoute
                location={ this.props.location }
                path={ `${GLOBAL_PATH_PREFIX}/settings` }
                icon="settings"
                name="Settings"
              />

              <div className="v-divider" />

              <AccountDropdown isEnterprise={ true } location={ this.props.location } />

            </div>
          </div>
        </div>
      </nav>
    );
  }

}

class NavbarRoute extends React.Component {

  itemClassByPath = () => {
    const { location, path } = this.props;
    if (location.pathname === path) {
      return 'active-navbar-item navbar-item';
    } else {
      return 'navbar-item';
    }
  };

  routeClassByPath = () => {
    const { location, path } = this.props;
    if (location.pathname === path) {
      return 'active-route';
    } else {
      return 'route';
    }
  };

  handleClick = ($event) => {
    const { location, path } = this.props;
    if (location.pathname === path) {
      $event.preventDefault();
    }
  };

  getPathWithSearchParameters = () => {
    const { location, path } = this.props;
    return `${path}${location.search}`;
  };

  constructor (props) {
    super(props);

    if (!props.path) {
      Logger.assert('NavbarRoute requires a path');
    }

    if (!props.name) {
      Logger.assert('NavbarRoute requires a name');
    }

    if (!props.icon) {
      Logger.assert('NavbarRoute requires an icon');
    }
  }

  render () {
    const { icon, name } = this.props;
    return (
      <div className={ `px-2 px-lg-3 px-xl-4 font-size-sm clickable route fix-ie ${this.itemClassByPath()}` }>
        <Link onClick={ this.handleClick } to={ this.getPathWithSearchParameters() }>
          <div className={ `${this.routeClassByPath()} row font-size-sm no-gutters d-flex h-100` }>
            <i className="fix-ie material-icons">{ icon }</i>
            <div className="fix-ie display-if-large-enough mr-2" />
            <div className="fix-ie display-if-large-enough pr-2">{ name }</div>
          </div>
        </Link>
      </div>
    );
  }

}

const mapStateToProps = state => {
  const user = state.user.user;
  let isPOPinAdmin = false;
  try {
    if (user) {
      const role = User.getRoleType(user);
      isPOPinAdmin = role === RoleType.POPIN_ADMIN;
    }
  } catch (e) {
    Logger.error('Failed to resolve user role for navbar gating', e);
  }
  return {
    orgName: (user && User.hasTenant(user)) ? Tenant.getName(User.getTenant(user)) : '',
    isPOPinAdmin
  };
};

export default connect(mapStateToProps, {})(EnterpriseNavbar);
